(function () {
  'use strict';

  angular.module('ringbaPortal').component('changelogPreviewBtn', {
    controller: ChangelogPreviewBtnController,
    controllerAs: 'vm',
    bindings: {
      diff: '<',
      wide: '<'
    },
    templateUrl: '/scripts/shared/components/changelog/changelog-delta/changelog-preview-btn.view.html'
  });

  function ChangelogPreviewBtnController() {
    const vm = this;
    vm.$onInit = onInit;

    function onInit() {
      vm.popPosition = 'auto ' + (vm.wide ? 'right' : 'left');
    }
  }
})();
